import type { Cell, Table as ReactTable, Row, RowData } from "@tanstack/react-table";
import type { ReactNode } from "react";
import {
  getColumnSizeStyle,
  getPinnedColumnStyle,
  getStickyScrollMarginStyle,
} from "../../table-pinning";
import { BodyCell, BodyRow } from "./styled";

export interface TableBodyProps<TData extends RowData> {
  readonly table: ReactTable<TData>;
  readonly rows: Array<Row<TData>>;
  readonly renderCell: (cell: Cell<TData, unknown>) => ReactNode;
}

const TableBody = <TData extends RowData>({
  table,
  rows,
  renderCell,
}: TableBodyProps<TData>) => {
  const scrollMarginStyle = getStickyScrollMarginStyle(table);

  return (
    <tbody>
      {rows.map((row, index) => {
        const cells = [
          ...row.getLeftVisibleCells(),
          ...row.getCenterVisibleCells(),
          ...row.getRightVisibleCells(),
        ];

        return (
          <BodyRow key={row.id}>
            {cells.map((cell) => (
              <BodyCell
                key={cell.id}
                isEven={index % 2 === 0}
                data-pinned={cell.column.getIsPinned() || undefined}
                style={{
                  ...scrollMarginStyle,
                  ...getColumnSizeStyle(cell.column),
                  ...getPinnedColumnStyle(cell.column, table),
                }}
              >
                {renderCell(cell)}
              </BodyCell>
            ))}
          </BodyRow>
        );
      })}
    </tbody>
  );
};

export default TableBody;
